var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flow-transition-card',{attrs:{"flow-id":_vm.flowId,"item":_vm.item,"origin":_vm.stateName,"ingress":_vm.computedIsDestination,"dismiss":_vm.dismiss}})}
var staticRenderFns = []

export { render, staticRenderFns }